export interface Customer {
  id: number
  tenantId: number
  name: string
  phone: string
  source: string
  status: string
  ownerUserId?: number
  ownerDeptId?: number
  createdAt: string
}

export interface CreateCustomerRequest {
  name: string
  phone: string
  source: string
  ownerUserId?: number
  ownerDeptId?: number
}

export interface UpdateCustomerRequest {
  name?: string
  phone?: string
  source?: string
  status?: 'NEW' | 'FOLLOWING' | 'CLOSED'
}

export interface AssignCustomerRequest {
  ownerUserId: number
  ownerDeptId?: number
}

export interface CrmRule {
  code: string
  name: string
  description: string
  enabled: boolean
}

export const CRM_PERMISSIONS = {
  adminInspect: 'platform:crm:inspect',
  workbenchView: 'crm:workbench:view',
  decorationView: 'crm:decoration:view',
  decorationManage: 'crm:decoration:manage',
  customerView: 'crm:customer:view',
  customerCreate: 'crm:customer:create',
  customerUpdate: 'crm:customer:update',
  customerAssign: 'crm:customer:assign',
  ruleManage: 'crm:rule:manage',
  clientView: 'crm:client:view',
  clientSubmit: 'crm:client:submit'
} as const

export const CRM_PERMISSION_LIST = Object.values(CRM_PERMISSIONS)
